import { Injectable } from '@angular/core';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { BadRequestErrorCode } from '../types/bad-request-error-code';
import { BadRequestErrorMessageParameter } from '../enums/bad-request-error-message-parameter';

@Injectable({
  providedIn: 'root',
})
export class BadRequestErrorMessageProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<BadRequestErrorCode, (params?: Record<BadRequestErrorMessageParameter, string>) => string>([
    ['04dedf9e-caec-4eb9-9d1f-538104d9af54', () => 'Nie można usunąć marki kosmetycznej powiązanej z kosmetykami.'],
    ['07c2bfeb-b27b-47be-8922-831fbe232eb8', () => 'Wybrany produkt podrzędny nie jest dostępny.'],
    ['148b5e0f-13cd-431e-974e-c9b950652319', () => 'Nie można usunąć pliku powiązanego z obiektami występującymi w systemie.'],
    ['3146cf64-df80-4391-97ff-9f0a8c27bc2c', () => 'Wybrany produkt nie istnieje.'],
    ['405dd14a-5ab7-464f-8c0a-9bc9c05cc694', () => 'Nie można usunąć cechy produktu, która jest powiązana z produktami.'],
    ['435e63f3-9108-4862-a5c1-564240476adf', () => 'Nie można usunąć kraju, który jest powiązany z metodą dostawy.'],
    ['77ec81db-b8b6-4c62-ba50-fcf9373e7b34', () => 'Nie można usunąć marki kosmetycznej powiązanej z towarami w magazynie.'],
    ['835ad345-4f57-4968-9473-73ba44bce1c7', (params?) => `Nie można zatwierdzić wydania zewnętrznego, ponieważ następujące towary przekraczają swoje stany magazynowe: ${params?.[BadRequestErrorMessageParameter.Goods]}.`],
    ['97c89714-42fb-400a-8016-eb3c00f5c9fb', () => 'Nie można usunąć marki kosmetycznej, która jest powiązana z produktami.'],
    ['9d31077d-8ebb-4eb2-8c32-ac6849abad11', () => 'Nie można zatwierdzić wydania zewnętrznego.'],
    ['b19b8bf4-a51f-466d-9f00-ce2ddb60d5dc', () => 'Nie można usunąć cechy produktu powiązanej z kosmetyku.'],
    ['b8c2e07d-f6c8-4a54-aad4-7d9aeb96d9b7', () => 'Nie można usunąć kategorii, która ma przypisane boxy kosmetyczne.'],
    ['b93a120c-d111-4bf9-9ebe-299212d2948f', () => 'Przekazanie identyfikatora produktu podrzędnego jest wymagane aby kupić produkt złożony.'],
    ['bc4c0151-2904-41a5-8ac7-d72aaf24bc5c', () => 'Nie można usunąć kosmetyku który jest powiązany z boxem kosmetycznym.'],
    ['de1b264f-26db-4654-a00f-536f177d8f11', () => 'Odmowa anulowania z systemu płatności.'],
    ['e5fe135b-ea57-44e8-bdc8-8fddfe267ce0', () => 'Nie można usunąć lokalizacji powiązanej z towarami.'],
    ['e6714288-9736-4184-bc53-5af663573868', () => 'Brak środków na koncie do wykonania zwrotu.'],
    ['f31f3d2c-d003-41d1-bf1c-bcb1d67a42b9', () => 'Wybrany produkt nie jest dostępny.'],
    ['f70ee3d1-8dc3-449f-8f46-333e7054a307', () => 'Wybranego zamówienia nie można anulować.'],
    ['fc13a824-128d-4521-a233-8af513d39634', () => 'Wybrany zasób nie może zostać usunięty.'],
    ['c944c3a0-cdfa-4007-a5ae-e11eb2795e0b', () => 'Brak etykiet do pobrania.'],
    ['108cf803-fd09-49ff-9495-97753677ac61', () => 'Aktualnie sprzedawany box nie został ustawiony.'],
    ['7430257d-13b4-46a1-b6a9-2e6ee5933ca8', () => 'Istnieje uruchomione w tle zadanie powiązane z wybraną akcją.'],
    ['8ce847a4-d027-457f-94d9-298fdf1f2c23', () => 'Brak bazowej faktury dla zamówienia, aby wygenerować korektę.'],
    ['cbc0f279-11ca-47ef-b3e0-f65556f7a718', () => 'Subskrypcja jest właśnie przetwarzana. W tym czasie nie można wprowadzać zmian. Spróbuj ponownie za chwilę.'],
  ]);

  public message(
    code: BadRequestErrorCode,
    params?: Record<BadRequestErrorMessageParameter, string>,
  ): string {
    const result = this.entries.get(code);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The error message entry for "${code}" not found.`,
      );
    }

    return result(params);
  }
}
